"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      display: 'flex',
      alignItems: 'flex-start',
      width: '50%',
      maxWidth: '50%',
      justifyContent: 'flex-start',
      padding: theme.spacing(4)
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      padding: theme.spacing(2),
      width: '100%'
    }), (0, _defineProperty2.default)(_root, '@media(max-width: 425px)', {
      padding: 0,
      paddingBottom: theme.spacing(2),
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }), _root),
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing(1)
    },
    date: {
      display: 'flex',
      paddingBottom: theme.spacing(1),
      '& > span:not(:last-of-type)': {
        paddingRight: theme.spacing(1)
      }
    },
    text: {
      maxWidth: 390
    },
    link: {
      color: theme.palette.common.black,
      fontWeight: 300,
      fontSize: 18
    },
    image: {
      width: theme.spacing(10),
      minWidth: theme.spacing(10),
      '& > img': {
        width: 80,
        maxWidth: 80,
        minWidth: 80,
        height: 80,
        maxHeight: 80,
        minHeight: 80
      }
    },
    comments: {
      paddingLeft: theme.spacing(1),
      borderLeft: '1px solid rgba(0,0,0,.3)'
    }
  };
}, {
  name: 'NewsListItem'
});

var getNewsHref = function getNewsHref(href) {
  return "/news".concat(href);
};

function NewsListItem(_ref) {
  var article = _ref.article,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["article", "classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.image
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: article.teaserImage,
    alt: article.title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: getNewsHref(article.href),
    className: classes.link
  }, article.title), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    className: classes.text
  }, article.teaserText)));
}

process.env.NODE_ENV !== "production" ? NewsListItem.propTypes = {
  article: _propTypes.default.shape({
    comments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    href: _propTypes.default.string.isRequired,
    teaserImage: _propTypes.default.string,
    teaserText: _propTypes.default.string,
    title: _propTypes.default.string
  }).isRequired,
  classes: _propTypes.default.shape({
    comments: _propTypes.default.string,
    image: _propTypes.default.string,
    link: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string,
    textContainer: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
NewsListItem.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = NewsListItem;
exports.default = _default;